import { NgModule } from '@angular/core';
import { FiAppearanceSidebarEditModule } from './edit/edit.module';
import { FiAppearanceSidebarViewComponent } from './view/view.component';
import { CommonModule } from '@angular/common';
import { UtilitiesModule } from '../../utilities/utilities.module';
import { WidgetModule } from '../../widget/widget.module';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';

@NgModule({
    imports: [CommonModule, UtilitiesModule, FiAppearanceSidebarEditModule, WidgetModule, FiPageHeaderModule],
    declarations: [FiAppearanceSidebarViewComponent],
    exports: [FiAppearanceSidebarEditModule, FiAppearanceSidebarViewComponent],
})
export class FiAppearanceSidebarModule {}
